<template lang="pug">
  span.expand-collapse-icons
    a
      span.expand-icon(v-if="!expand")
      span.collapse-icon(v-else)
</template>

<script>
export default {
  name: 'ExpandButton',

  props: {
    expand: Boolean
  }
}
</script>

<style lang="stylus">
.expand-collapse-icons
  font-size 15px
  top -.3em
  position relative
</style>



// WEBPACK FOOTER //
// src/components/elements/ExpandButton.vue